var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"margin":"16px auto auto auto"},attrs:{"src":_vm.logoImageSrc,"width":_vm.width,"aria-label":"Application logo","title":"Application logo","role":"presentation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }